<template>
  <div class="print-model">
    <div id="printMe" ref="printMe">
      <InvoiceComponent :item="item" :loading="loading" />
      <div class="signeture-container">
        <div
          class="signeture-item"
          v-for="(signeture, index) in options.invoices_signatures_data"
          :key="index"
        >
          <div class="signeture-name">{{ signeture.name }}</div>
          <div class="signeture-points">..........................</div>
        </div>
      </div>
      <p class="pioneer-data">تم الإنشاء بواسطة Pioneer للبرمجيات 01019654321</p>
    </div>
  </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue'
import InvoiceComponent from './components/invoice.vue'
export default {
  data() {
    return {
      path: '/invoices',
      item: {},
      unitsCoefficients: [],
      loading: true
    }
  },
  methods: {
    getitem() {
      this.loading = true
      this.item = this.$parent.printedInvoice
      let unitsCoefficients = []
      unitsCoefficients = [...new Set(unitsCoefficients)]
      this.unitsCoefficients = this.$database.unitsCoefficients.filter((row) =>
        unitsCoefficients.includes(row.id)
      )
      this.unitsCoefficients = this.unitsCoefficients.sort(
        this.$dynamicSort({ orderBy: 'id', orderType: 'desc' })
      )
      if (this.$option.tax_invoice) {
        var sellerNameBuf = this.getTlvForValue('1', this.$option.name)

        var vatRegistrationNameBuf = this.getTlvForValue('2', this.$option.tax_number)
        var timeBuf = this.getTlvForValue('3', this.item.created_at)
        var totalInvoiceBuf = this.getTlvForValue('4', this.item.total.toFixed(1).toString())
        var taxAmountBuf = this.getTlvForValue('5', this.item.tax.toFixed(1).toString())
        var tagBufsArray = [
          sellerNameBuf,
          vatRegistrationNameBuf,
          timeBuf,
          totalInvoiceBuf,
          taxAmountBuf
        ]
        var qrCodeBuf = Buffer.concat(tagBufsArray)
        var qrCodeB64 = qrCodeBuf.toString('base64')
        this.item.qrCode = qrCodeB64
      }
      this.loading = false
      var myel = this
      setTimeout(function () {
        var text = document.getElementById('printMe').innerHTML
        document.getElementById('printMe').remove()
        var myframe = document.getElementById('inviceIframe')
        myframe.contentDocument.body.innerHTML = text
        setTimeout(function () {
          myframe.focus()
          myframe.contentWindow.print()
          myel.colse()
        }, 100)
      }, 20)
    },
    getTlvForValue(tagNum, tagValue) {
      var tagBuf = Buffer.from([tagNum], 'utf8')

      var tagvalueBuf = Buffer.from(tagValue, 'utf8')

      var tagValueLenBuf = Buffer.from([tagvalueBuf.length], 'utf8')

      var bufsArray = [tagBuf, tagValueLenBuf, tagvalueBuf]

      return Buffer.concat(bufsArray)
    },
    colse() {
      this.$parent.printedInvoice = false
    }
  },
  mounted() {
    this.getitem()
  },
  props: ['options'],
  components: {
    QrcodeVue,
    InvoiceComponent
  }
}
</script>
